export const boardCopilotTour = {
  key: "boardCopilot",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-copilot-prompt"]',
      content: t("Tour_BoardCopilot_Prompt"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-copilot-suggestions"]',
      content: t("Tour_BoardCopilot_Suggestions"),
      placement: "right",
    },
    {
      target: '[data-tour="board-copilot-apply"]',
      content: t("Tour_BoardCopilot_Apply"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-copilot-history"]',
      content: t("Tour_BoardCopilot_History"),
      placement: "bottom",
    },
  ],
};
